import React, { ReactElement, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API, ApiErrorHandler } from "../../../services/api";
import { PaginatedListInterface } from '../../../interfaces/PaginatedList';
import { range, useQuery } from '../../../utils/helper';
import { HostInterface } from '../../../interfaces/HostInterface';
import { useAuth } from "../../../hooks/useAuth";

export default (): ReactElement => {
  const { logout } = useAuth();
  const [hosts, setHosts] = useState<PaginatedListInterface<HostInterface>>();

  const page = useQuery().get('page');

  useEffect(() => {
    (async () => {
      try{

        const result = await API.get(`host?page=${page ? page : 1}`);
        setHosts(result);
      }catch (e){
        ApiErrorHandler(e, {
          onUnauthorizedError: logout
        })
      }
    })();
  }, [page]);

  return (
    <div className="content">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Seminarleiter</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid">
        <div className="card">
          <div className="card-body table-responsive p-0">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {hosts?.items.map((host, key) => (
                  <tr key={key}>
                    <td>
                      <Link to={`/seminars/hosts/${host.id}`}>{host.name}</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="card-footer clearfix">
            <ul className="pagination pagination-sm m-0 float-right">
              {range(hosts?.numberOfPages).map((page, key) => (
                <li className="page-item" key={key}>
                  <Link
                    className="page-link"
                    to={`/seminars/hosts?page=${page}`}
                  >
                    {page}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
